import PropTypes from 'prop-types';

import Image from '../shared/image.component';

const LivingTypesSection = (props) => {
    
    const {
        lifeSectionHeaderOne,
        lifeSectionParagraphOne,
        lifeSectionHeaderTwo,
        lifeSectionParagraphTwo,
        lifeSectionIconOne,
        lifeSectionIconOneAlt,
        lifeSectionIconTwo,
        lifeSectionIconTwoAlt,
        lifeSectionImage,
        lifeSectionImageAlt,
    } = props;

    return (

        <div style={{ marginBottom: 0 }} className="container-root container-root-maxWidthLg section-home-oclub-form">

            <div className='main-grid-container'>
                
                <div className='living-types-section-image-grid main-grid-item main-grid-lg-6 main-grid-md-12 main-grid-sm-12'>
                    <div className='living-types-section-image-wrapper'>
                        <span className='living-types-section-image-span'>
                            <span className='living-types-section-image-span-inner'>
                                <Image
                                    src={lifeSectionImage}
                                    alt={lifeSectionImageAlt}
                                    width={1939}
                                    height={1504}
                                />
                            </span>
                        </span>
                    </div>
                </div>

                <div className='living-types-section-text-grid main-grid-item main-grid-lg-6 main-grid-md-12 main-grid-sm-12'>

                    <div className='living-types-section-types'>

                        <div className='living-types-section-types-wrapper'>

                            <div>
                                <div className='living-types-section-icon-container'>
                                    <Image
                                        src={lifeSectionIconOne}
                                        alt={lifeSectionIconOneAlt}
                                        width={75}
                                        height={61}
                                    />
                                </div>
                            </div>

                            <div className='living-types-section-text-wrapper'>
                                <h3 className='living-types-section-title'>{lifeSectionHeaderOne}</h3>
                                <div className='living-types-section-paragraph'
                                    dangerouslySetInnerHTML={{ __html: lifeSectionParagraphOne }}
                                ></div>
                            </div>

                        </div>

                        <div className='living-types-section-types-wrapper'>

                            <div>
                                <div className='living-types-section-icon-container'>
                                    <Image
                                        src={lifeSectionIconTwo}
                                        alt={lifeSectionIconTwoAlt}
                                        width={40}
                                        height={40}
                                    />
                                </div>
                            </div>

                            <div className='living-types-section-text-wrapper'>
                                <h3 className='living-types-section-title'>{lifeSectionHeaderTwo}</h3>
                                <div className='living-types-section-paragraph'
                                    dangerouslySetInnerHTML={{ __html: lifeSectionParagraphTwo }}
                                ></div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default LivingTypesSection;

LivingTypesSection.propTypes = {
    lifeSectionHeaderOne: PropTypes.string,
    lifeSectionParagraphOne: PropTypes.string,
    lifeSectionHeaderTwo: PropTypes.string,
    lifeSectionParagraphTwo: PropTypes.string,
    lifeSectionIconOne: PropTypes.string,
    lifeSectionIconOneAlt: PropTypes.string,
    lifeSectionIconTwo: PropTypes.string,
    lifeSectionIconTwoAlt: PropTypes.string,
    lifeSectionImage: PropTypes.string,
    lifeSectionImageAlt: PropTypes.string,
};

